import styled from "@emotion/styled";
import { theme } from "../../../utils/Theme";

export const Container = styled.div`
  padding: 64px 16px 16px 20px;
`;
